const state = {
  userInfo: '',
  newsCount: '',
  taskInfo: {},
  headAction: '',
  leftAction: '',
  behaviorBody: [], // 行为分析数据
};

export default state;
